import React, { useEffect } from "react";
import { SHOPKEEPER_OPTIONS } from "@/data/zones";
import { User } from "lucide-react";

export const ShopkeeperDialogue = ({ open, line, onClose, onPick }) => {
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      data-testid="shopkeeper-dialogue"
      className="fixed inset-x-0 bottom-0 z-[90] flex justify-center p-3 sm:p-5"
    >
      <div className="w-full max-w-2xl rounded-lg border-[3px] border-kirana-brown bg-card paper-grain p-4 hard-shadow">
        <div className="flex items-start gap-3">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border-2 border-kirana-brown bg-kirana-red">
            <User className="h-7 w-7 text-white" />
          </div>
          <div className="flex-1">
            <p className="font-signboard text-sm font-bold text-kirana-red">Sharma Kaka</p>
            <p className="font-signboard text-xl leading-tight text-kirana-brown">{line}</p>
          </div>
          <button
            data-testid="shopkeeper-close"
            onClick={onClose}
            className="rounded-md border-2 border-kirana-brown bg-kirana-cream px-2 py-1 text-xs font-bold text-kirana-brown"
          >
            Bas dekh raha hoon
          </button>
        </div>
        <div className="mt-3 flex flex-wrap gap-2">
          {SHOPKEEPER_OPTIONS.map((o) => (
            <button
              key={o.text}
              data-testid={`shopkeeper-opt-${o.zone}`}
              onClick={() => onPick(o.zone)}
              className="rounded-full border-2 border-kirana-brown bg-kirana-gold px-3 py-1 text-sm font-bold text-kirana-brown transition-transform hover:scale-105"
            >
              {o.text}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
